<template>
	<el-checkbox-group size="small" v-model="allStatus">
		<el-checkbox-button v-for="item in options" :key="item.value" :label="item.value" @change="changeValue">{{item.label}}</el-checkbox-button>
	</el-checkbox-group>
  
</template>

<script>
export default {
  name: 'selectBussinessStatus',
  props:{
		allStatus: ""
	}, 
  data() {
    return {
      options: [
        {
          value: "task-0",
          label: '未申报',
        },
        {
          value: "task-1",
          label: '排队中',
        },
        {
          value: "task-2",
          label: '申报中',
        },
        {
          value: "task-4",
          label: '失败',
        },
        {
          value: "business-2",
          label: '申报成功,无需扣款',
        },
        {
          value: "business-3",
          label: '申报失败',
        },
        {
          value: "business-4",
          label: '提交三金处理中',
        },
        {
          value: "business-5",
          label: '申报成功,待缴款',
        },
        {
          value: "business-6",
          label: '申报成功,已缴款',
        }
      ],
    };
  },

  mounted() {
    
  },

  methods: {
    changeValue() {
      this.$emit('update:allStatus', this.allStatus)
      this.$emit("success",this.allStatus)
    },   
  },
};
</script>

<style lang="scss" scoped>

</style>